module.exports = __webpack_public_path__ + "img/trail_bic_red.gif";